import React from 'react';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AB_NAME } from '../../../../constants/sitesettings';
import { useWhitelabel } from '../../../../reducers/whitelabel';
import { ListContentLayout } from '../../../Layouts/ListContentLayout';
import { ListGrid } from '../../../ListGrid';
import { ReduxBanner } from '../../../ReduxBanner';
import { SpecialOffersBlock } from '../../../SpecialOffersBlock';
import { ListContainerProps, withListContainer } from '../../hoc/withListContainer';
import { DateGroupListContainer } from '../DateGroupList';

import { SportDescriptionsMenu } from './descriptions';
import styles from './styles.module.scss';

export const NewsContainer = (props: ListContainerProps & { rubric: string }) => {
  const { tabsForSpecialOffers, rubric } = props;
  const isWhitelabel = useWhitelabel();
  const isMobile = useIsMobile();

  const isNewsSportRubric = 'novosti-sporta';

  const banner = <ReduxBanner lazy abName={AB_NAME} type={BANNER_TYPES.TGBM_7} />;
  return (
    //@ts-ignore
    <DateGroupListContainer
      heading={
        <>
          <ListContentLayout.Heading as={Typography.Heading} level={2} className={styles.heading}>
            {rubric === isNewsSportRubric ? 'Новости спорта' : 'Новости'}
          </ListContentLayout.Heading>
          {rubric === isNewsSportRubric && (
            <Space className={isMobile && 'h-pl-20 h-pr-20'}>
              <SportDescriptionsMenu />
            </Space>
          )}
        </>
      }
      withImages={false}
      injectConfig={{
        0: {
          item: !!tabsForSpecialOffers.length && (
            <ListGrid.Cell type="full">
              <SpecialOffersBlock tabs={tabsForSpecialOffers} className={'h-mt-24'} isMainPage />
            </ListGrid.Cell>
          ),
          1: !isWhitelabel && banner && (
            <ListGrid.Cell type="full" className="h-mt-32 h-mb-32">
              {banner}
            </ListGrid.Cell>
          ),
        },
      }}
      {...props}
    />
  );
};

export const NewsList = withListContainer()(NewsContainer);
